import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconPeace: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPeace"><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M12 12L5.75 18.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M12 12L18.25 18.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M12 3V21" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconPeace;
